<template>
  <div>
    <div class="">
      <div class="row">
        <div class="col-12">
          <custom-collapse id="additional-question-collapse" class="mx-md-3">
            <draggable
              :disabled="!isDragAndDropEnable"
              force-fallback
              ghost-class="ghost"
              :list="input"
              @end="dragging = false"
              @start="dragging = true"
            >
              <custom-collapse-item
                v-for="(item, key) in input"
                :id="`additional-question-collapse-item-${key + 1}`"
                :key="`additional-question-collapse-item-${key + 1}`"
                :ref="`additional-question-collapse-item-${key + 1}`"
                :auto-expand-collapse-enabled="false"
                :button-icon="'far fa-times-circle color-red'"
                class="collapse-item mt-3"
                :class="{ 'border border-danger rounded': !item.valid }"
                :disabled="isReadOnly || isDragAndDropEnable"
                :expanded="item.expanded"
                :expanded-icon="'fas fa-plus-circle color-gray-2'"
                icon-class-when-button-disabled="fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center"
                :keep-btn-visible="false"
                parent-id="additional-question-collapse"
                :show-icon-when-button-disabled="isDragAndDropEnable"
                :title="title(item, key)"
                @actionButtonClick="quit(item, key)"
                @expandButtonClick="expand(item, key)"
              >
                <validation-observer :ref="`additional-question-${key}`">
                  <div v-if="!isLocality">
                    <div class="row">
                      <div class="col-12">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <div class="text">
                            Pregunta o Descripción:
                          </div>
                          <custom-input
                            v-model="item.name"
                            :custom-error-msg="'El campor es requerido.'"
                            :error="errors[0]"
                            maxlength="500"
                            placeholder="Escribe tu Pregunta o Descripción"
                          />
                        </validation-provider>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 col-md-5">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                        >
                          <div class="text">
                            Opción de Respuesta:
                          </div>
                          <select
                            v-model="item.typeId"
                            class="form-control"
                            :class="{ error: errors.length > 0 }"
                            custom-error-msg="El campo es requerido."
                            :error="errors[0]"
                            placeholder="Seleccione"
                            @change="onAnswerTypeChange(item)"
                          >
                            <option disabled hidden selected value="">
                              Seleccione
                            </option>
                            <option
                              v-for="(type, keyType) in answersTypes"
                              :key="keyType"
                              class="fa"
                              :value="type.id"
                              v-html="`${type.icon} ${type.name}`"
                            />
                          </select>
                          <custom-error
                            v-if="errors.length > 0"
                            :message="'El campo es requerido'"
                            variant="no-border mt-1"
                          />
                        </validation-provider>
                      </div>
                    </div>
                    <vertical-inputs
                      v-if="item.typeId == selection.simpleVertical"
                      :input.sync="item.answers"
                    />

                    <simple-with-child
                      v-if="item.typeId == selection.simpleWithChild"
                      :answers-types="answersTypes"
                      :child-questions.sync="item.childQuestions"
                      :input.sync="item.answers"
                      :parent-index="key"
                    />

                    <multiple-selection
                      v-if="item.typeId == selection.multipleHorizontal"
                      :input.sync="item.answers"
                      :orientation="'horizontal'"
                    />

                    <multiple-selection
                      v-if="item.typeId == selection.multipleVertical"
                      :input.sync="item.answers"
                      :orientation="'vertical'"
                    />

                    <div
                      v-if="item.typeId == selection.numericalText"
                      class="row mt-3"
                    >
                      <div class="col-12 col-md-5">
                        <div class="text">
                          Texto Numérico:
                        </div>
                        <input
                          class="form-control custom-bg-disabled"
                          disabled
                          :min="0"
                          placeholder="0"
                          type="number"
                        />
                      </div>
                    </div>
                    <div
                      v-if="item.typeId == selection.openText"
                      class="row mt-3"
                    >
                      <div class="col-12 col-md-5">
                        <div class="text">
                          Texto Abierto:
                        </div>
                        <custom-text-area
                          disabled
                          :maxlength="0"
                          placeholder="Escriba un comentario"
                        />
                      </div>
                    </div>

                    <horizontal-inputs
                      v-if="item.typeId == selection.simpleHorizontal"
                      :input.sync="item.answers"
                    />

                    <div
                      v-if="item.typeId == selection.document"
                      class="col-12 my-5 p-3 document-bg rounded-lg"
                      style="background-color: #F1F6F4;"
                    >
                      <label class="data-label">
                        Archivo
                      </label>
                      <action-button
                        class="w-100 disabled"
                        :disabled="true"
                        i="fas fa-file-plus"
                        text="Presione aquí para anejar documento"
                        variant="outline-grey mr-3 pl-3 pr-4"
                      />
                    </div>
                  </div>
                  <div v-else>
                    <locality-form
                      v-model="item.location"
                      :is-read-only="true"
                    />
                  </div>
                </validation-observer>
              </custom-collapse-item>
            </draggable>
          </custom-collapse>
        </div>
      </div>
      <div v-if="!isReadOnly && !isLocality" class="row mt-3">
        <div
          class="col-12 col-md flex-grow-1 d-flex align-items-center justify-content-end pr-md-4 pt-3"
        >
          <action-button
            class="px-3"
            i="fas fa-file-plus"
            text="Añadir"
            variant="success"
            @click="add()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import { getAnswersTypes } from '@/modules/bidQuestionConfig/api.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomInput from 'CustomInput';
import CustomCollapse from '@/components/common/CustomCollapse.vue';
import CustomCollapseItem from '@/components/common/CustomCollapseItem.vue';
import VerticalInputs from './VerticalInputs';
import CustomError from 'custom-error';
import HorizontalInputs from './HorizontalInputs';
import MultipleSelection from './MultipleSelection.vue';
import CustomTextArea from 'CustomTextArea';
import SimpleWithChild from './SimpleWithChild.vue';
import draggable from 'vuedraggable';
import LocalityForm from './LocalityForm.vue';
import SELECTION from '@/utils/constants/announcementQuestionnaireQuestionType';

export default {
  name: 'Questions',
  components: {
    ActionButton,
    CustomCollapse,
    CustomCollapseItem,
    CustomInput,
    VerticalInputs,
    HorizontalInputs,
    CustomError,
    MultipleSelection,
    CustomTextArea,
    SimpleWithChild,
    draggable,
    LocalityForm,
  },
  mixins: [alertMixin],
  props: {
    input: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isLocality: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selection: {
        simpleVertical: SELECTION.SIMPLEVERTICAL,
        simpleHorizontal: SELECTION.SIMPLEHORIZONTAL,
        multipleVertical: SELECTION.MULTIPLEVERTICAL,
        multipleHorizontal: SELECTION.MULTIPLEHORIZONTAL,
        openText: SELECTION.OPENTEXT,
        numericalText: SELECTION.NUMERICALTEXT,
        simpleWithChild: SELECTION.SIMPLEWITHCHILD,
        document: SELECTION.DOCUMENT,
      },
      answersTypes: [],
      answers: [],
      currentComponent: {
        name: '',
        value: '',
        props: {},
      },
      isDragAndDropEnable: false,
      dragging: false,
    };
  },
  computed: {
    isAllExpanded() {
      return this.input.every((x) => x.expanded);
    },
    title() {
      return (item, key) => (item.name ? item.name : `Pregunta ${key + 1}`);
    },
    id() {
      const { id } = this.$route.params;
      if (!id) return null;
      return Number(id);
    },
  },
  async mounted() {
    await this.getAnswersTypes();
  },
  methods: {
    async getAnswersTypes() {
      const { data } = await getAnswersTypes();
      this.answersTypes = data;
    },

    async add() {
      const valid = await this.validate();
      if (!valid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );

        return;
      }
      const item = {
        name: null,
        typeId: '',
        answers: [],
        childQuestions: [],
        valid: true,
        expanded: true,
      };
      this.input.push(item);

      this.expand(item, this.input.length - 1);
      this.$emit('add', item);
    },
    reorganize() {
      this.isDragAndDropEnable = !this.isDragAndDropEnable;
      this.input.forEach((x) => (x.expanded = false));
    },
    toggleExpandCollapse() {
      if (this.isDragAndDropEnable) return;
      const expand = !this.isAllExpanded;
      this.input.forEach((x) => (x.expanded = expand));
    },
    expandAll(expanded = true) {
      this.input.forEach((x) => (x.expanded = expanded));
    },
    expand(item, key) {
      if (this.isDragAndDropEnable) return;
      this.input
        .filter((x, i) => i !== key)
        .forEach((x) => (x.expanded = false));
      setTimeout(() => (item.expanded = !item.expanded), 100);
    },
    async quit(item, index) {
      if (this.isDragAndDropEnable) return;
      const confirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea remover la pregunta documentada? `,
        'Si',
        'No'
      );

      if (!confirmed) return;
      this.input.splice(index, 1);
      this.$emit('quit', item, index);
    },
    onAnswerTypeChange(item) {
      const types = [
        SELECTION.SIMPLEHORIZONTAL,
        SELECTION.SIMPLEVERTICAL,
        SELECTION.MULTIPLEHORIZONTAL,
        SELECTION.MULTIPLEVERTICAL,
        SELECTION.SIMPLEWITHCHILD,
      ];
      item.answers = [];
      item.childQuestions = [];
      if (types.includes(item.typeId)) {
        item.answers = [
          { id: 1, name: '' },
          { id: 2, name: '' },
        ];
        item.childQuestions = [];
      }
    },
    async validate() {
      if (!this.input.length) return true;
      const forms = this.input.map((item, key) => {
        const validator = this.$refs[`additional-question-${key}`][0];
        return validator.validate().then((val) => (item.valid = val));
      });
      await Promise.all(forms);
      return this.input.every((x) => x.valid);
    },
  },
};
</script>

<style scoped lang="scss">
.text-gray {
  color: #727272;
}

.boder {
  border-right: 1px #b5c3bc solid;
}

.panel-content {
  padding: 24px;
  background: #f7f7f7;
  border-radius: 4px;
}

.text {
  margin-bottom: 5px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  letter-spacing: -0.005em;
  text-align: left;
}

.answer-content {
  align-self: stretch;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  display: inline-flex;
}

.outline-muted {
  color: #11291b;
  background-color: #ffffff;
  border-color: #e2e2e2;
}

.outline-dark-gray {
  color: #3f5b60;
  background-color: #ffffff;
  border-color: #3f5b60;
}

.collapse-item ::v-deep .card-header {
  padding: 0.75rem 1rem !important;
  background-color: #fff;
}

.collapse-item ::v-deep .tag-badge-pei {
  background: none;
}

.collapse-item ::v-deep .shadow2 {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.collapse-item ::v-deep .card-body.shadow2 {
  background-color: #ffffff !important;
}

.collapse-item ::v-deep .shadow2 {
  background-color: #ffffff !important;
}

::v-deep .dropdown .btn {
  color: #495057;
  opacity: 0.8;
  font-weight: 400;
  border: var(--vs-border-width) var(--vs-border-style) var(--vs-border-color) !important;
  border-radius: var(--vs-border-radius);
}

option.fa {
  font-weight: 400 !important;
  font-family: 'Font Awesome 5 Pro', 'Lato', sans-serif;
}

select.error {
  border: solid 1px #ff0018 !important;
}
.custom-bg-disabled {
  background-color: #f8f8f8 !important;
}
select {
  font-family: 'Font Awesome 5 Pro', 'Lato', sans-serif;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.document-bg ::v-deep .form-control,
.document-bg ::v-deep .file-input-container {
  background-color: #f1f6f4 !important;
}

.ab-btn-outline-grey {
  background-color: #fafafa;
  border: #e2e2e2 solid 1px;
  color: #11291b;
}
</style>
